/* eslint-disable no-nested-ternary */
import { RouteObject, useRoutes, Navigate } from 'react-router-dom';

// routes
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import MagicLinkRoutes from './MagicLinkRoutes';
import DocsPage from 'views/docs';

import { lazy, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'store';
import { getActiveFields } from 'store/slices/auth';
import Loadable from 'ui-component/Loadable';

// TEST - Releases
const ReleasesPage = Loadable(lazy(() => import('views/releases')));

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    const dispatch = useDispatch();
    const { vendor, filteredRoutes } = useSelector((state) => state.auth);

    const [data, setdata] = useState<RouteObject>(MainRoutes);

    useEffect(() => {
        vendor &&
            dispatch(
                getActiveFields({
                    idMerchant: vendor.idMerchant,
                    idProvider: vendor.idProvider
                })
            );

        if (!filteredRoutes.length) return;

        setdata((prev: any) => ({
            ...prev,
            children: filteredRoutes
        }));
    }, [filteredRoutes, vendor]);

    return useRoutes([
        {
            path: '/__/auth/*',
            element: <DocsPage />
        },
        {
            path: '/loolu/docs',
            element: <DocsPage />
        },
        {
            path: '/loolu/releases',
            element: <ReleasesPage />
        },
        MagicLinkRoutes,
        LoginRoutes,
        data,
        {
            path: '/',
            element: <Navigate to="/loolu/admin/login" replace />
        },
        {
            path: '*',
            element: <Navigate to="/loolu/admin" replace />
        }
    ]);
}
